import { classicAppreciation } from './01_classic_appreciation';
import { classicAppreciationFrame } from './01_classic_appreciation_frame';
import { simpleAppreciation } from './02_simple_appreciation';
import { simpleAppreciationFrame } from './02_simple_appreciation_frame';
import { participationDetailed } from './03_participation_detailed';
import { participationDetailedFrame } from './03_participation_detailed_frame';
import { ornateParticipation } from './04_ornate_participation';
import { ornateParticipationFrame } from './04_ornate_participation_frame';
import { darkBorderParticipation } from './05_dark_border_participation';
import { darkBorderParticipationFrame } from './05_dark_border_participation_frame';
import { latticeBorder } from './06_lattice_border';
import { latticeBorderFrame } from './06_lattice_border_frame';
import { companyBranded } from './07_company_branded';
import { companyBrandedFrame } from './07_company_branded_frame';
import { modernAchievement } from './08_modern_achievement';
import { modernAchievementFrame } from './08_modern_achievement_frame';
import { geometricTeal } from './09_geometric_teal';
import { geometricTealFrame } from './09_geometric_teal_frame';

export const DIPLOMA_TEMPLATES = [
  classicAppreciation(),
  classicAppreciationFrame(),
  simpleAppreciation(),
  simpleAppreciationFrame(),
  participationDetailed(),
  participationDetailedFrame(),
  ornateParticipation(),
  ornateParticipationFrame(),
  darkBorderParticipation(),
  darkBorderParticipationFrame(),
  latticeBorder(),
  latticeBorderFrame(),
  companyBranded(),
  companyBrandedFrame(),
  modernAchievement(),
  modernAchievementFrame(),
  geometricTeal(),
  geometricTealFrame()
];
